/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_OnboardingInputs */

const de__field_onboarding = /** @type {(inputs: _Field_OnboardingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onboarding`)
};

/**

* @param {_Field_OnboardingInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_onboarding = /** @type {((inputs?: _Field_OnboardingInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_OnboardingInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_onboarding(inputs)
});